import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as productsSelector, actions as productsActions } from 'ducks/supplierEnquiry/purchasing/products';
import { fetch } from 'api/supplierEnquiry/purchasing/products';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';
import { IApplicationState } from 'ducks/reducers';

export const mapStateToProps = (state: IApplicationState) => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierPurchasingProducts',
    columnDefs: productsSelector.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: productsSelector.gridOptions(state),
    filterRow: productsSelector.filterRow(state, ((supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier'))),
    selectedFilters: productsSelector.selectedFilters(state),
    appliedFilters: productsSelector.filterRow(state, '') && filterSelectors.getFilters(state, productsSelector.filterRow(state, '').formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      Supplier: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  };
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: productsActions.setSelected,
  applyFilters: filterActions.applyFilters
};
